import React from 'react';
import { Row, Col, Button, Form, Spinner } from 'react-bootstrap';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import { FaSliders } from 'react-icons/fa6';

const TableHeader = ({ actif, setActif, selectedProduct, setShowEditModal, loading, setShow }) => {
  return (
    <div className="d-lg-flex justify-content-between">
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto">
          <AdvanceTableSearchBox className="w-10" placeholder="Recherche par mot clé" />
        </Col>
        <Col xs="auto" className="pe-0">
          <Button
            variant="falcon-default"
            size="sm"
            transform="shrink-4"
            className="mx-2"
            onClick={() => setShow(true)}
          >
            <FaSliders />
            <span className="d-none d-sm-inline-block ms-1">Filter</span>
          </Button>
        </Col>
        {/* <Col>
          <Form.Switch
            aria-label="Default select example"
            className="mx-1 mb-2 mb-sm-0"
            checked={actif}
            onChange={() => setActif(!actif)}
          />
        </Col> */}
        <Col>
          <Button
            variant="falcon-default"
            // transform="shrink-4"
            style={{ width: '150px', fontSize: '12px' }}
            className="mx-2"
            onClick={() => setShowEditModal(true)}
          >
            Modifier Produits
          </Button>
        </Col>
        <Col>
          {loading && (
            <>
              <Spinner animation="border" role="status" size="sm" />
              <span>Chargement...</span>
            </>
          )}
        </Col>
      </Row>
      <div className="border-bottom border-200 my-3"></div>
      <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        <div
          className="bg-300 mx-3 d-none d-lg-block d-xl-none"
          style={{ width: '1px', height: '29px' }}
        ></div>
      </div>
    </div>
  );
};

export default TableHeader;
